'use client'

import { PRODUCT_COLORS } from '@/shared/constants'
import Link, { LinkProps } from 'next/link'
import { usePathname } from 'next/navigation'
import { productLogoMock } from './mock/product-logo-mock'

export function TreeunfeLogo({ ...props }: LinkProps) {
  const pathName = usePathname()

  const getProductIcon = () => {
    const matchingKey = Object.keys(PRODUCT_COLORS)?.find((key) =>
      pathName?.toUpperCase()?.includes(key),
    )

    return (
      productLogoMock?.find((product) => product.id === matchingKey)?.icon ??
      productLogoMock[0].icon
    )
  }

  return (
    <Link
      {...props}
      className="flex items-center gap-x-2 [@media(max-width:400px)]:w-[110px]"
      aria-label="Treeunfe logo"
    >
      {getProductIcon()}
    </Link>
  )
}
